import { render } from "./reportEatserveDetail.vue?vue&type=template&id=190dc12d"
import script from "./reportEatserveDetail.vue?vue&type=script&lang=js"
export * from "./reportEatserveDetail.vue?vue&type=script&lang=js"

import "./reportEatserveDetail.vue?vue&type=style&index=0&id=190dc12d&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__